var _path, _path2, _circle, _circle2, _circle3, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _circle4, _rect49, _rect50, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBonhomme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 800C522.73 800 622.222 700.508 622.222 577.778C622.222 455.048 522.73 355.556 400 355.556C277.27 355.556 177.778 455.048 177.778 577.778C177.778 700.508 277.27 800 400 800Z",
    fill: "#E1E8ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.667 244.444C266.667 170.8 326.356 111.111 400 111.111C473.622 111.111 533.333 170.8 533.333 244.444C533.333 318.089 473.622 377.778 400 377.778C326.356 377.778 266.667 318.089 266.667 244.444Z",
    fill: "#E1E8ED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 244.444,
    r: 133.333,
    fill: "#4E4B4D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 244.444,
    r: 121.481,
    fill: "#262A31"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 240,
    r: 71.1111,
    fill: "#393A3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_608_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.018 271.151C384.672 271.167 384.447 271.334 384.447 271.691V287.625C384.447 287.903 384.638 288.154 384.931 288.154H412.157C412.402 288.154 412.597 288.131 412.712 287.793C412.712 287.793 415.471 278.771 415.519 278.608C415.621 278.267 415.555 278.094 415.277 277.909C406.41 271.972 393.146 271.111 387.131 271.111C386.268 271.111 385.554 271.129 385.021 271.151",
    fill: "#716E6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 397.778,
    y: 122.963,
    width: 3.7037,
    height: 32.5926,
    fill: "#E2D752"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 337.037,
    y: 139.05,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(-32.9276 337.037 139.05)",
    fill: "#E2D752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 477.037,
    y: 291.339,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(-59.472 477.037 291.339)",
    fill: "#E2D752"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 294.814,
    y: 183.894,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(-58.3662 294.814 183.894)",
    fill: "#E2D752"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 442.222,
    y: 322.705,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(-32.0287 442.222 322.705)",
    fill: "#E2D752"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 353.09,
    y: 320,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(29.5072 353.09 320)",
    fill: "#E2D752"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 320.311,
    y: 287.407,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(58.261 320.311 287.407)",
    fill: "#E2D752"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 459.226,
    y: 137.037,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(31.4487 459.226 137.037)",
    fill: "#E2D752"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 503.293,
    y: 180.741,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(58.3241 503.293 180.741)",
    fill: "#E2D752"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 510.729,
    y: 197.778,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(70.4633 510.729 197.778)",
    fill: "#E2D752"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 516.488,
    y: 212.593,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(77.1294 516.488 212.593)",
    fill: "#E2D752"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 518.345,
    y: 228.148,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(84.9766 518.345 228.148)",
    fill: "#E2D752"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 518.473,
    y: 258.637,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(95.1942 518.473 258.637)",
    fill: "#E2D752"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 516.077,
    y: 274.385,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(106.088 516.077 274.385)",
    fill: "#E2D752"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 510.739,
    y: 289.612,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(114.719 510.739 289.612)",
    fill: "#E2D752"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 495.299,
    y: 316.438,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(129.548 495.299 316.438)",
    fill: "#E2D752"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 485.166,
    y: 328.285,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(136.076 485.166 328.285)",
    fill: "#E2D752"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 473.293,
    y: 338.553,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(142.97 473.293 338.553)",
    fill: "#E2D752"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 446.237,
    y: 354.543,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(161.562 446.237 354.543)",
    fill: "#E2D752"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 431.024,
    y: 360.127,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(169.362 431.024 360.127)",
    fill: "#E2D752"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 415.63,
    y: 362.838,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(177.292 415.63 362.838)",
    fill: "#E2D752"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 384.591,
    y: 362.909,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-173.582 384.591 362.909)",
    fill: "#E2D752"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 368.797,
    y: 360.202,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-161.7 368.797 360.202)",
    fill: "#E2D752"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 354.091,
    y: 354.839,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-157.457 354.091 354.839)",
    fill: "#E2D752"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 327.847,
    y: 338.827,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-143.783 327.847 338.827)",
    fill: "#E2D752"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 314.294,
    y: 328.992,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-130.984 314.294 328.992)",
    fill: "#E2D752"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 304.264,
    y: 317.466,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-127.263 304.264 317.466)",
    fill: "#E2D752"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 289.489,
    y: 290.058,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-114.19 289.489 290.058)",
    fill: "#E2D752"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 284.083,
    y: 275.629,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-105.04 284.083 275.629)",
    fill: "#E2D752"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 280.868,
    y: 259.288,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-94.9782 280.868 259.288)",
    fill: "#E2D752"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 280.741,
    y: 228.87,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-88.1172 280.741 228.87)",
    fill: "#E2D752"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 283.703,
    y: 212.501,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-71.7103 283.703 212.501)",
    fill: "#E2D752"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 288.889,
    y: 197.624,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-65.0906 288.889 197.624)",
    fill: "#E2D752"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 305.185,
    y: 171.466,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-48.4517 305.185 171.466)",
    fill: "#E2D752"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 315.028,
    y: 159.34,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-46.2095 315.028 159.34)",
    fill: "#E2D752"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 326.667,
    y: 149.044,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-37.772 326.667 149.044)",
    fill: "#E2D752"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 354.074,
    y: 133.881,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-21.9721 354.074 133.881)",
    fill: "#E2D752"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 368.889,
    y: 128.416,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-10.5388 368.889 128.416)",
    fill: "#E2D752"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 384.444,
    y: 124.571,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(-4.9619 384.444 124.571)",
    fill: "#E2D752"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 415.546,
    y: 124.444,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(9.61784 415.546 124.444)",
    fill: "#E2D752"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 431.577,
    y: 127.407,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(18.6463 431.577 127.407)",
    fill: "#E2D752"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 445.675,
    y: 132.819,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(23.8044 445.675 132.819)",
    fill: "#E2D752"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 472.371,
    y: 148.148,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(38.0372 472.371 148.148)",
    fill: "#E2D752"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 484.762,
    y: 158.519,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(46.9326 484.762 158.519)",
    fill: "#E2D752"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 494.66,
    y: 171.111,
    width: 1.46337,
    height: 17.6728,
    transform: "rotate(56.0556 494.66 171.111)",
    fill: "#E2D752"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 397.778,
    y: 333.333,
    width: 3.7037,
    height: 32.5926,
    fill: "#E2D752"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 488.889,
    y: 245.926,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(-90 488.889 245.926)",
    fill: "#E2D752"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 278.519,
    y: 245.926,
    width: 3.7037,
    height: 32.5926,
    transform: "rotate(-90 278.519 245.926)",
    fill: "#E2D752"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.63,
    cy: 244.074,
    r: 123.889,
    stroke: "#4E4B4D",
    strokeWidth: 10
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 417.043,
    y: 262.531,
    width: 88.7112,
    height: 15.1456,
    transform: "rotate(-147.247 417.043 262.531)",
    fill: "#B0A83E"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 376.189,
    y: 254.615,
    width: 115.468,
    height: 11.2281,
    transform: "rotate(-37.5671 376.189 254.615)",
    fill: "#E2D752"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.722 185.073L474.553 193.108L467.644 184.241L475.722 185.073Z",
    fill: "#E2D752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M342.193 205.338L350.662 201.796L342.449 214.514L342.193 205.338Z",
    fill: "#B0A83E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M511.111 133.333C511.111 157.867 491.2 177.778 466.667 177.778H333.333C308.8 177.778 288.889 157.867 288.889 133.333V44.4444C288.889 19.9111 308.8 0 333.333 0H466.667C491.2 0 511.111 19.9111 511.111 44.4444V133.333Z",
    fill: "#DD2E44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M555.556 155.556C555.556 167.822 545.622 177.778 533.333 177.778H266.667C254.4 177.778 244.444 167.822 244.444 155.556C244.444 143.289 254.4 133.333 266.667 133.333H533.333C545.622 133.333 555.556 143.289 555.556 155.556Z",
    fill: "#8D3943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M500 333.333H300C281.578 333.333 266.667 348.244 266.667 366.667C266.667 381.156 275.978 393.378 288.889 397.956V555.556C288.889 567.844 298.844 577.778 311.111 577.778H333.333C345.6 577.778 355.556 567.844 355.556 555.556V400H500C518.4 400 533.333 385.089 533.333 366.667C533.333 348.244 518.4 333.333 500 333.333Z",
    fill: "#DD2E44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M422.222 533.333C422.222 545.622 412.289 555.556 400 555.556C387.733 555.556 377.778 545.622 377.778 533.333C377.778 521.044 387.733 511.111 400 511.111C412.289 511.111 422.222 521.044 422.222 533.333ZM422.222 644.444C422.222 656.733 412.289 666.667 400 666.667C387.733 666.667 377.778 656.733 377.778 644.444C377.778 632.156 387.733 622.222 400 622.222C412.289 622.222 422.222 632.156 422.222 644.444Z",
    fill: "#414042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230.978 446.244L154.267 413.378L142.111 349.689C139.8 337.644 128.244 329.756 116.111 332.022C104.067 334.333 96.1555 345.956 98.4444 358.022L104.978 392.244L75.4222 379.578C64.1333 374.711 51.0666 379.978 46.2444 391.244C41.4 402.533 46.6444 415.6 57.9111 420.422L74.4222 427.489L50.9555 450.956C42.2666 459.644 42.2666 473.689 50.9555 482.378C55.2888 486.711 60.9777 488.889 66.6666 488.889C72.3555 488.889 78.0444 486.711 82.3777 482.378L118.4 446.356L213.467 487.089C216.311 488.333 219.289 488.889 222.222 488.889C230.844 488.889 239.044 483.844 242.644 475.422C247.489 464.133 242.244 451.089 230.978 446.244ZM740.356 378.911L707.8 368.067L726.8 349.067C735.489 340.378 735.489 326.333 726.8 317.644C718.111 308.956 704.067 308.956 695.378 317.644L678.689 334.333L665.978 283.511C663 271.622 650.911 264.289 639.044 267.356C627.133 270.333 619.889 282.4 622.889 294.311L642.044 370.978L562.044 450.978C553.355 459.667 553.355 473.711 562.044 482.4C566.4 486.711 572.089 488.889 577.778 488.889C583.467 488.889 589.156 486.711 593.489 482.378L672.667 403.2L726.289 421.089C728.644 421.867 731.022 422.222 733.333 422.222C742.644 422.222 751.311 416.333 754.4 407.022C758.289 395.378 752 382.8 740.356 378.911Z",
    fill: "#FFAC33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224 46.9556C220.6 41.8667 213.711 40.4667 208.6 43.8889L188.889 57.0222V33.3333C188.889 27.2 183.911 22.2222 177.778 22.2222C171.644 22.2222 166.667 27.2 166.667 33.3333V57.0222L146.956 43.8889C141.822 40.4667 134.956 41.8667 131.556 46.9556C128.156 52.0445 129.533 58.9556 134.644 62.3556L157.756 77.7778L134.644 93.1778C129.533 96.6 128.156 103.489 131.556 108.6C133.689 111.822 137.222 113.556 140.822 113.556C142.933 113.556 145.067 112.956 146.978 111.689L166.667 98.5333V122.222C166.667 128.356 171.644 133.333 177.778 133.333C183.911 133.333 188.889 128.356 188.889 122.222V98.5333L208.6 111.667C210.489 112.933 212.644 113.533 214.756 113.533C218.356 113.533 221.867 111.8 224.022 108.578C227.422 103.489 226.044 96.5778 220.933 93.1778L197.8 77.7778L220.911 62.3778C226.022 58.9556 227.4 52.0667 224 46.9556ZM135.111 202.511C131.711 197.422 124.822 196.022 119.711 199.444L100 212.578V188.889C100 182.756 95.0222 177.778 88.8889 177.778C82.7556 177.778 77.7778 182.756 77.7778 188.889V212.578L58.0667 199.444C52.9333 196.022 46.0667 197.422 42.6667 202.511C39.2667 207.6 40.6445 214.511 45.7556 217.911L68.8667 233.311L45.7556 248.711C40.6445 252.111 39.2667 259.022 42.6667 264.111C44.8 267.333 48.3333 269.067 51.9333 269.067C54.0445 269.067 56.1778 268.467 58.0889 267.2L77.7778 254.089V277.778C77.7778 283.911 82.7556 288.889 88.8889 288.889C95.0222 288.889 100 283.911 100 277.778V254.089L119.711 267.222C121.6 268.489 123.756 269.089 125.867 269.089C129.467 269.089 132.978 267.356 135.133 264.133C138.533 259.044 137.156 252.133 132.044 248.733L108.911 233.333L132.022 217.933C137.133 214.511 138.511 207.622 135.111 202.511ZM135.111 580.289C131.711 575.2 124.822 573.8 119.711 577.2L100 590.356V566.667C100 560.533 95.0222 555.556 88.8889 555.556C82.7556 555.556 77.7778 560.533 77.7778 566.667V590.356L58.0667 577.222C52.9333 573.822 46.0445 575.2 42.6667 580.311C39.2667 585.4 40.6445 592.311 45.7556 595.711L68.8667 611.111L45.7556 626.511C40.6445 629.911 39.2667 636.822 42.6667 641.911C44.8 645.133 48.3333 646.867 51.9333 646.867C54.0445 646.867 56.1778 646.267 58.0889 645L77.7778 631.867V655.556C77.7778 661.689 82.7556 666.667 88.8889 666.667C95.0222 666.667 100 661.689 100 655.556V631.867L119.711 645C121.6 646.267 123.756 646.867 125.867 646.867C129.467 646.867 132.978 645.133 135.133 641.911C138.533 636.822 137.156 629.911 132.044 626.511L108.911 611.111L132.022 595.711C137.133 592.289 138.511 585.4 135.111 580.289ZM753.356 211.111L776.467 195.711C781.578 192.311 782.956 185.4 779.556 180.311C776.156 175.222 769.267 173.822 764.156 177.222L744.444 190.356V166.667C744.444 160.533 739.467 155.556 733.333 155.556C727.2 155.556 722.222 160.533 722.222 166.667V190.356L702.511 177.222C697.378 173.822 690.489 175.2 687.111 180.311C683.711 185.4 685.089 192.311 690.2 195.711L713.311 211.111L690.2 226.511C685.089 229.911 683.711 236.822 687.111 241.911C689.244 245.133 692.778 246.867 696.378 246.867C698.489 246.867 700.622 246.267 702.533 245L722.244 231.867V255.556C722.244 261.689 727.222 266.667 733.356 266.667C739.489 266.667 744.467 261.689 744.467 255.556V231.867L764.178 245C766.067 246.267 768.222 246.867 770.333 246.867C773.933 246.867 777.444 245.133 779.6 241.911C783 236.822 781.622 229.911 776.511 226.511L753.356 211.111ZM757.333 513.622C753.933 508.533 747.044 507.133 741.933 510.533L722.222 523.689V500C722.222 493.867 717.244 488.889 711.111 488.889C704.978 488.889 700 493.867 700 500V523.689L680.289 510.556C675.156 507.156 668.267 508.533 664.889 513.644C661.489 518.733 662.867 525.644 667.978 529.044L691.089 544.444L667.978 559.844C662.867 563.245 661.489 570.156 664.889 575.244C667.022 578.467 670.556 580.2 674.156 580.2C676.267 580.2 678.4 579.6 680.311 578.333L700.022 565.2V588.889C700.022 595.022 705 600 711.133 600C717.267 600 722.244 595.022 722.244 588.889V565.2L741.956 578.333C743.844 579.6 746 580.2 748.111 580.2C751.711 580.2 755.222 578.467 757.378 575.244C760.778 570.156 759.4 563.245 754.289 559.844L731.178 544.444L754.289 529.044C759.356 525.622 760.733 518.733 757.333 513.622ZM665.356 93.1778L642.244 77.7778L665.356 62.3778C670.467 58.9778 671.844 52.0667 668.444 46.9778C665.044 41.8889 658.156 40.4889 653.044 43.8889L633.333 57.0222V33.3333C633.333 27.2 628.356 22.2222 622.222 22.2222C616.089 22.2222 611.111 27.2 611.111 33.3333V57.0222L591.4 43.8889C586.267 40.4889 579.378 41.8667 576 46.9778C572.6 52.0667 573.978 58.9778 579.089 62.3778L602.2 77.7778L579.089 93.1778C573.978 96.5778 572.6 103.489 576 108.578C578.133 111.8 581.667 113.533 585.267 113.533C587.378 113.533 589.511 112.933 591.422 111.667L611.111 98.5333V122.222C611.111 128.356 616.089 133.333 622.222 133.333C628.356 133.333 633.333 128.356 633.333 122.222V98.5333L653.044 111.667C654.933 112.933 657.089 113.533 659.2 113.533C662.8 113.533 666.311 111.8 668.467 108.578C671.844 103.489 670.467 96.6 665.356 93.1778Z",
    fill: "#88C9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_608_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.1111,
    height: 17.037,
    fill: "white",
    transform: "translate(384.444 271.111)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonhomme);
export default __webpack_public_path__ + "static/media/bonhomme.7f2d0c8078227bf0a39ba8b81df2147a.svg";
export { ForwardRef as ReactComponent };